angular.module('app').factory('hiddenGamesService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        return {
            getProviders: function () {
                return restAngular.
                    one("casinoprovider/getSkinProviders").
                    get()
            },
            getCategories: function () {
                return restAngular.
                    one("casinocategory/getSkinCategories").
                    get()
            },
            getProvidersBySkinId: function (requestData) {
                return restAngular.
                    one("casinoprovider/getSkinProviders").
                    post("", requestData)
            },
            getProvidersBySkinIds: function (requestData) {
                return restAngular.
                    one("casinoprovider/getSkinProviders").
                    post("", requestData)
            },
            getCategoriesBySkinId: function (requestData) {
                return restAngular.
                    one("casinocategory/getSkinCategories").
                    customGET(param(requestData))
            },
            changeProviderOrder: function (requestData) {
                return restAngular.
                    one("/casinoprovider/changeorderskinproviders").
                    post('', requestData)
            },
            changeCategoryOrder: function (requestData) {
                return restAngular.
                    one("/casinocategory/changeorderskincategories").
                    post('', requestData)
            },
            updateProvider: function (requestData) {
                return restAngular.
                    one("/casinoprovider/changevisibilityskinprovider").
                    post('', requestData)
            },
            updateCategory: function (requestData) {
                return restAngular.
                    one("casinocategory/changevisibilityskinCategory").
                    post('', requestData)
            },
            updateTournamentStatus: function (requestData) {
                return restAngular.
                one("casinotournament/switchEnabledStatus").
                post('', requestData)
            },
            changeLabel: function (requestData) {
                return restAngular.
                one("casinoprovider/changebadgeskinprovider").
                post('', requestData)
            },
            changeCategoryLabel: function (requestData) {
                return restAngular.
                one("casinocategory/changebadgeskincategory").
                post('', requestData)
            },
            changeJustice: function (requestData) {
                return restAngular.
                one("casinoprovider/changeJusticeSkinProvider").
                post('', requestData)
            },
            getTournamentEnabledStatus: function (requestData) {
                return restAngular.
                one("casinotournament/getEnabledStatus").
                customGET(param(requestData))
            },
            changeIconSkinCategory: function (requestData) {
                return restAngular.
                one("casinocategory/changeIconSkinCategory").
                post('', requestData)
            },

        }
    }
]);
